import { useEffect, useRef } from 'react';
import { pingAdminSession } from '../utils/api';

const useSessionKeepAlive = (enabled = true) => {
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!enabled) return;

    const pingSession = async () => {
      try {
        const response = await pingAdminSession();
        
        if (response.data?.data?.csrf_token) {
          localStorage.setItem('csrf_token', response.data.data.csrf_token);
        }
        
        console.log('[Session Keep-Alive] Session refreshed');
      } catch (error) {
        console.error('[Session Keep-Alive] Failed to refresh session:', error);
      }
    };

    const initialTimeout = setTimeout(pingSession, 60 * 1000);

    intervalRef.current = setInterval(pingSession, 5 * 60 * 1000);

    return () => {
      clearTimeout(initialTimeout);
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [enabled]);
};

export default useSessionKeepAlive;
